import React from 'react';
import GoogleLogin from 'react-google-login';
import { MDBContainer, MDBCardBody, MDBCardTitle, MDBCardText, MDBCard, MDBCardImage } from 'mdbreact';
import styled from 'styled-components';

const MiddleCard = styled.div`
  margin: 0 auto;

  @media (max-width: 767px) {
    width: 100%;
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    width: 40%;
  }
  @media (min-width: 1025px) {
    width: 30%;
  }
`;

const googleLogin = ({ onGoogleSignIn }) => (
  <MDBContainer style={{position: "relative"}}>
    <MiddleCard>
      <MDBCard wide className="mx-auto cyan lighten-2">
        <MDBCardImage cascade className="img-fluid" src="https://www.fasmedo.com/wp-content/uploads/2019/03/20190114.202.jpg"/>
        <MDBCardBody cascade>
          <MDBCardTitle className="white-text">Fasmedo Admin</MDBCardTitle>
          <MDBCardText className="white-text">The first head-mounted wireless camera with stylish
            design and best autofocus performance
          </MDBCardText>
          <GoogleLogin
            clientId="909940500684-gkmosvm2u6m31j8t1sf5rivdjhqs0g2p.apps.googleusercontent.com"
            buttonText="Login with Google"
            onSuccess={onGoogleSignIn}
            onFailure={(err) => {console.log(err)}}
          />
        </MDBCardBody>
      </MDBCard>
    </MiddleCard>
  </MDBContainer>
);

export default googleLogin;
